import { async } from '@firebase/util';
import { Button, Tooltip } from '@mui/material'
import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { v4 } from 'uuid';
import ModalArchivo from '../Components/Alertas/ModalArchivo';
import ModalDiagrama from '../Components/Alertas/ModalDiagrama';
import { auth, db } from '../firebase/firebase';
import SaveIcon from '@mui/icons-material/Save';
import { EditRoadOutlined } from '@mui/icons-material';
import AlertaSistema from '../Components/Alertas/AlertaSistema';
import SaveAsIcon from '@mui/icons-material/SaveAs';

const GuardarDiagrama = (props) => {

    const {nodos, lineas, idDiagrama, diagramaTitulo, diagramaFecha, diagramaCole} = props;
    const user = auth.currentUser;
    
    const [diagramas, setDiagramas] = useState('');
    
    const [nodosDiagrama, setNodosDiagrama] = useState([]);
    const [lineasDiagrama, setLineasDiagrama] = useState([]);
    const [idActual, setIdActual] = useState(idDiagrama);
    const [titulo, setTitulo] = useState(diagramaTitulo);
    const [diagramaColeccion, setDiagramaColeccion] = useState(diagramaCole);
    const [coleccionesDiagrama, setColeccionesDiagrama] = useState([]);

    const [esNuevo, setEsNuevo] = useState(true);
    const [abrirModal, setAbrirModal] = useState(false);

    const handleClose = () => setAbrirModal(false);

    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
        setTimeout(() => {
            setOpen(false);
        }, 3000);
    };

    const obtenerDiagramas = async() =>{
        try {
          const querySnapshot = await getDocs(collection(db, user.uid));
          const arrayData = querySnapshot.docs.map( doc => 
            (
              {id: doc.id}
            ))      
          setDiagramas(arrayData);
          
        } catch (error) {
          
        }
    }

    useEffect(() => {
        obtenerDiagramas();
    }, [])

    /* 
        Esta funcion se encargar de ver 
        si el diagrama que esta siendo editado 
        actualmente es nuevo o ya existente, y 
        en función de esto, se ejecuta alguna 
        de las funciones correspondientes
    */

    const guardarDiagrama = async() =>{
        await obtenerDiagramas();
        let nuevo = true;
                
        diagramas.forEach((diagrama)=>{
            if(diagrama.id === idActual){
                nuevo = false;
            }
            
        })
        
        if(nuevo && esNuevo){
            setTitulo('Nuevo diagrama '+ diagramas.length);
            setAbrirModal(true);
            
        }else{
            actualizarDiagrama();
        }
        
        setLineasDiagrama([]);
        setNodosDiagrama([]);
    }

    // Funcion para guardar nuevo diagrama
    const guardarNuevo = async(e) =>{
        
        e.preventDefault();
        
        let colecciones = []
        let idDiagram = '';

        coleccionesDiagrama.forEach((cole) =>{
            colecciones.push(cole.nombre);
        })
        
        const today = new Date();
        const now = today.toLocaleDateString();

        nodos.forEach((nodo)=>{
            let newNode = JSON.stringify(nodo);
            nodosDiagrama.push(newNode);
        })

        lineas.forEach((linea) =>{
            let newLine = JSON.stringify(linea);
            lineasDiagrama.push(newLine);
        })


        await addDoc(collection(db, user.uid),{
            titulo: titulo,
            fecha: now,
            lineas: lineasDiagrama,
            nodos: nodosDiagrama,
            coleccion: colecciones
        }).then(function(docRef) {
            /* console.log("Document written with ID: ", docRef.id); */
            setIdActual(docRef.id)
            idDiagram=docRef.id

            let nuevo = {
                idDocumento: idDiagram,
                titulo: titulo
            }
    
            coleccionesDiagrama.forEach(async( cole )=>{
                console.log(nuevo, cole)
                await updateDoc(doc(db, 'colecciones', cole.id),{
                    diagramas: arrayUnion(nuevo)
                })
            })
        })
        .catch(function(error) {
            /* console.error("Error adding document: ", error); */
        });
        /* let nuevo = {
            idDocumento: idDiagram,
            titulo: titulo
        }

        console.log(idDiagrama)
        
        coleccionesDiagrama.forEach(async( cole )=>{
            await updateDoc(doc(db, 'colecciones', cole.id),{
                diagramas: arrayUnion(nuevo)
            })
        }) */

        /* actualizarDiagramas(); */

        setAbrirModal(false);
        setEsNuevo(false);
        //Se vacia el array para evitar 
        //sobreescribir los nodos existentes
        //con el fin de evitar errores por key
        //(eliminar lineas de abajo para ver el error al guardar)
        setLineasDiagrama([]);
        setNodosDiagrama([]);
        setColeccionesDiagrama([]);
        
        handleClick();
    }

    //Funcion para actualizar un diagrama existente
    const actualizarDiagrama = async() =>{
        /* console.log(idActual) */
        
        const today = new Date();
        const now = today.toLocaleDateString();

        nodos.forEach((nodo)=>{
            let newNode = JSON.stringify(nodo);
            nodosDiagrama.push(newNode);
        })

        lineas.forEach((linea) =>{
            let newLine = JSON.stringify(linea);
            lineasDiagrama.push(newLine);
        })

        await updateDoc(doc(db, user.uid, idActual),{
            titulo: titulo,
            fecha: now,
            lineas: lineasDiagrama,
            nodos: nodosDiagrama,
            /* coleccion: diagramaColeccion */
        })
        handleClick();
    }

    return (
        <div>
            {
                user ? 
                (
                    <Tooltip title="Guardar Diagrama" >
                        <Button onClick={guardarDiagrama} type='submit' variant="outlined">
                            <SaveIcon/>
                        </Button>
                    </Tooltip>
                )
                :
                (
                    <Button type='submit' variant="outlined" disabled onClick={()=>{console.log('nada')}}>
                        <SaveIcon/>
                    </Button>
                )
            }
            
            { abrirModal && (
                <ModalDiagrama
                    abrirModal={abrirModal}
                    handleClose={handleClose}
                    titulo={titulo}
                    setTitulo={setTitulo}
                    guardarNuevo={guardarNuevo}
                    setColeccionesDiagrama={setColeccionesDiagrama}
                    coleccionesDiagrama={coleccionesDiagrama}
                />
            )}
            <AlertaSistema
                open={open}
                mensaje={'Guardado con éxito'}
            />
        </div>
    )
}

export default GuardarDiagrama